// @flow

module.exports = {

  Responsive: {
    LG_MIN: 1200
  },

  Key: {
    ENTER: 13
  },

  Graph: {
    DONUT_SUMMARY_COLORS: [
      '#D64541',
      '#E67E22',
      '#F9BF3B',
      '#446CB3',
      '#9dc212'
    ],
    DONUT_ORDERS_COLORS: [
      '#F9BF3B',
      '#446CB3',
      '#9dc212'
    ],
    BAR_PAYMENTS_COLORS: [
      '#D64541',
      '#E67E22',
    ],
  },

  Image: {
    PLACEHOLDER: '/img/default_restaurant.png', // TODO: change

    // TODO: Use the one on sdk ViewConstants
    DEFAULT_RESTAURANT: '/img/default_restaurant.png',

    // TODO: Use the one on sdk ViewConstants
    DEFAULT_RESTAURANT_LOGO: '/img/user_default_picture.png', // TODO: change

    DEFAULT_RESTAURANT_MENU_PICTURE: '/img/Menu_hippo@3.jpg',

    LOADING_BAR: '/img/loading-bars.svg',

    DEFAULT_NEWS_PICTURE: '/img/draughtboard.png',

    USER_MAP_CURSOR: '/img/ic_user_location.svg',

    RestaurantMenu: {
      NO_IMAGE_FOR_CATEGORY: '/img/placeholder_category.png',

      NO_IMAGE_FOR_PRODUCT: '/img/placeholder_product.png',

      NO_IMAGE_FOR_MENU: '/img/placeholder_product.png',

      NO_IMAGE_FOR_OPTION: '/img/placeholder_product.png',

      NO_IMAGE_FOR_PRODUCT_OPTION: '/img/placeholder_product.png', // TODO: change

      NO_IMAGE_FOR_MENU_PART_CATEGORY_OPTION: '/img/placeholder_product.png',
    }
  },

  Timelapse: {
    Selection: {
      CUSTOM: 0,
      DAY: 1,
      WEEK: 2,
      MONTH: 3
    }
  },

  ColorPicker: {
    DEFAULT_COLOR: '#ccc',
    DEFAULT_COLORS_LIST: [
      '#468966',
      '#FFF0A5',
      '#FFB03B',
      '#B64926',
      '#8E2800',
      '#e1e1e1',
      '#D24D57',
      '#F22613',
      '#D91E18',
      '#96281B',
      '#EF4836',
      '#D64541',
      '#C0392B',
      '#CF000F',
      '#E74C3C',
      '#DB0A5B',
      '#F64747',
      '#F1A9A0',
      '#D2527F',
      '#E08283',
      '#F62459',
      '#E26A6A',
      '#DCC6E0',
      '#663399',
      '#674172',
      '#AEA8D3',
      '#913D88',
      '#9A12B3',
      '#BF55EC',
      '#BE90D4',
      '#8E44AD',
      '#9B59B6',
      '#446CB3',
      '#E4F1FE',
      '#4183D7',
      '#59ABE3',
      '#81CFE0',
      '#52B3D9',
      '#C5EFF7',
      '#22A7F0',
      '#3498DB',
      '#2C3E50',
      '#19B5FE',
      '#336E7B',
      '#22313F',
      '#6BB9F0',
      '#1E8BC3',
      '#3A539B',
      '#34495E',
      '#67809F',
      '#2574A9',
      '#1F3A93',
      '#89C4F4',
      '#4B77BE',
      '#5C97BF',
      '#4ECDC4',
      '#A2DED0',
      '#87D37C',
      '#90C695',
      '#26A65B',
      '#03C9A9',
      '#68C3A3',
      '#65C6BB',
      '#1BBC9B',
      '#1BA39C',
      '#66CC99',
      '#36D7B7',
      '#C8F7C5',
      '#86E2D5',
      '#2ECC71',
      '#16A085',
      '#3FC380',
      '#019875',
      '#03A678',
      '#4DAF7C',
      '#2ABB9B',
      '#00B16A',
      '#1E824C',
      '#049372',
      '#26C281',
      '#FDE3A7',
      '#F89406',
      '#EB9532',
      '#E87E04',
      '#F4B350',
      '#F2784B',
      '#EB974E',
      '#F5AB35',
      '#D35400',
      '#F39C12',
      '#F9690E',
      '#F9BF3B',
      '#F27935',
      '#E67E22',
      '#ECECEC',
      '#6C7A89',
      '#D2D7D3',
      '#EEEEEE',
      '#BDC3C7',
      '#ECF0F1',
      '#95A5A6',
      '#DADFE1',
      '#ABB7B7',
      '#F2F1EF',
      '#BFBFBF'
    ]
  },

  ColorView: {
    DEFAULT_COLOR: '#ccc',
    DEFAULT_SIZE: 25
  }

};



// WEBPACK FOOTER //
// ./scripts/constants/ViewConstants.js